module.exports = __webpack_public_path__ + "static/media/saint-kitts-and-nevis.6e1cd664.svg";